import {
  AccordionRadioGroup,
  Category,
  Option,
  OptionGroup,
  User,
} from '../../../../../types';
import { AsyncDataTransformer } from '../../../constants/AsyncDataTransformer';
import { toAccordionGroups } from './toAccordionGroups';
import { toOptionGroups } from './toOptionGroups';
import { toOptions } from './toOptions';
import { toUserOptions } from './toUserOptions';

export const transform = (
  transformer: AsyncDataTransformer,
  categories: Category[],
  users: User[],
): Option<string>[] | OptionGroup<string>[] | AccordionRadioGroup[] => {
  switch (transformer) {
    case AsyncDataTransformer.OptionGroups:
      return toOptionGroups(categories);
    case AsyncDataTransformer.AccordionGroups:
      return toAccordionGroups(categories);
    default:
      return categories.length ? toOptions(categories) : toUserOptions(users);
  }
};
